import request from './request'
const basUrl = '/api/skNewMedia' //正式 
// const basUrl = '/skNewMedia' //本地联调
// 登录
export const login = params => {
  return request({
    url: basUrl+'/media/index/login',
    method: 'post',
    data: params
  });
};
// 注册
export const register = params => {
  return request({
    url: basUrl+'/media/index/register',
    method: 'post',
    data: params
  });
};
//  发布信息
export const addApi = params => {
  return request({
    url: basUrl+'/media/information/submitInformation/save',
    method: 'post',
    data: params
  });
};
// 获取支付二维码
export const getPayCode = params => {
	return request({
	  url: basUrl+'/media/wechat/memberXs/getCode?accountId=' + params.accountId + '&paymentAmount=' + params.paymentAmount,
	  method: 'get',
		responseType: 'blob' // 👈 直接写死在这里
	});
};
//  查看是不是会员
export const queryIsMember = params => {
  return request({
    url: basUrl+'/media/wechat/member/queryIsMember',
    method: 'get',
    params: {
      ...params,
      noSpinning:true
    }
  });
};
// 获取用户信息
export const getUserInfo = params => {
  return request({
    url: basUrl+'/media/userAccount/getUserInfo?id='+params.accountId,
    method: 'post'
  });
};
// 获取省市县
export const areaList = params => {
  return request({
    url: basUrl+'/media/area/list',
    method: 'get',
    params: params
  });
};
// 获取地址列表
export const areaGetList = params => {
  return request({
    url: basUrl+'/media/area/getList',
    method: 'get',
    params: params
  });
};
// 新增地址列表
export const areaSaveOrUpdate = params => {
  return request({
    url: basUrl+'/media/area/saveOrUpdate',
    method: 'post',
    data: params
  });
};
// 设置为默认
export const setDefault = params => {
  return request({
    url: basUrl+'/media/area/setDefault',
    method: 'get',
    params: params
  });
};
// 删除
export const areaDelete = params => {
  return request({
    url: basUrl+'/media/area/delete',
    method: 'get',
    params: params
  });
};
// 获取订单列表
export const orderGetList = params => {
  return request({
    url: basUrl+'/media/wechat/userGoodsOrder/getList',
    method: 'get',
    params: params
  });
};

// 获取订单支付二维码
export const getOrderPayCode = params => {
	return request({
	  url: basUrl+'/media/wechat/userGoodsOrderXs/submitOrder?productid=' + params.productid + '&productname=' + params.productname + '&number=' + params.number + '&unitprice=' + params.unitprice + '&areaId=' + params.areaId + '&producttype=' + params.producttype + '&accountId=' + params.accountId + '&paymentAmount=' + params.paymentAmount + '&oldOrderno=' + params.oldOrderno,
	  method: 'get',
		responseType: 'blob' // 👈 直接写死在这里
	});
};
// 查看订单是不是已支付
export const queryOrder = params => {
  return request({
    url: basUrl+'/media/wechat/userGoodsOrder/queryOrderStatus',
    method: 'get',
    params: {
      ...params,
      noSpinning:true
    }
  });
};
//获取当前账号是否有发布审核权限
export const getAuthorityIs = params => {
  return request({
    url: basUrl+'/media/publish/review/permission',
    method: 'get',
    params: params
  });
};
//发布信息
export const getPublic = params => {
  return request({
    url: basUrl+'/media/publish/apply',
    method: 'post',
    data: params
  });
};
//获取当前账号发布历史
export const getRelHistory = params => {
  return request({
    url: basUrl+'/media/publish/my/list',
    method: 'get',
    params: params
  });
};

//获取审核列表
export const getReviewList = params => {
  return request({
    url: basUrl+'/media/publish/review/list',
    method: 'get',
    params: params
  });
};
//查看审核列表详情
export const getDetailRel = params => {
  return request({
    url: basUrl+'/media/publish/review/detail',
    method: 'get',
    params: params
  });
};
//通过发布信息
export const getPassRel = params => {
  return request({
    url: basUrl+'/media/publish/review/approve',
    method: 'post',
    data: params
  });
};
//驳回发布信息
export const getRejectRel = params => {
  return request({
    url: basUrl+'/media/publish/review/reject',
    method: 'post',
    data: params
  });
};
//个人中心详细信息
export const getMySummary = params => {
  return request({
    url: basUrl+'/media/user/center/summary',
    method: 'get',
    params: params
  });
};
//查询手机号认证状态
export const getCertifiedIs = params => {
  return request({
    url: basUrl+'/media/auth/sms/status',
    method: 'get',
    params: params
  });
};
//获取短信验证码
export const getCodeInt = params => {
  return request({
    url: basUrl+'/media/auth/sms/send',
    method: 'post',
    params: params
  });
};
//手机认证接口
export const getCertifiedInt = params => {
  return request({
    url: basUrl+'/media/auth/sms/verify',
    method: 'post',
    params: params
  });
};
//实名认证接口
export const getRealInt = params => {
  return request({
    url: basUrl+'/media/realname/submit',
    method: 'post',
    data: params
  });
};
//实名认证列表
export const getRealList = params => {
  return request({
    url: basUrl+'/media/realname/review/list',
    method: 'get',
    params: params
  });
};
//查看实名认证详情
export const getDetailReal = params => {
  return request({
    url: basUrl+'/media/realname/review/detail',
    method: 'get',
    params: params
  });
};
//通过实名认证
export const getPassReal = params => {
  return request({
    url: basUrl+'/media/realname/review/approve',
    method: 'post',
    data: params
  });
};
//驳回实名认证
export const getRejectReal = params => {
  return request({
    url: basUrl+'/media/realname/review/reject',
    method: 'post',
    data: params
  });
};
// 获取产品列表

export const getProductList = params => {
  return request({
    url: basUrl+'/media/product/list',
    method: 'get',
    params: params
  });
};